import { array, integer, maxValue, minValue, number, parse, pipe, type InferOutput } from 'valibot'
import { decodeStateMessageBytesUnchecked, encodeStateMessage, type PreferredLocalStateMapDisk } from '../engine/engineWasmCodec'
import { StateSchema, type State } from './State.type'

export const StateBytesSchema = array(
  pipe(
    number(),
    integer(),
    minValue(0),
    maxValue(255)
  )
)

export type StateBytes = InferOutput<typeof StateBytesSchema>

export function isStateBytes(value: unknown): value is StateBytes {
  return Array.isArray(value) && value.every((item) => Number.isInteger(item) && item >= 0 && item <= 255)
}

export function encodePersistedStateBytes(state: State): StateBytes {
  return Array.from(encodeStateMessage(state))
}

export function decodePersistedStateBytes(
  bytes: StateBytes,
  preferredLocalDisk?: PreferredLocalStateMapDisk
): State {
  return decodeStateMessageBytesUnchecked(Uint8Array.from(bytes), preferredLocalDisk)
}

export function decodePersistedStateData(
  data: unknown,
  preferredLocalDisk?: PreferredLocalStateMapDisk
): State {
  if (isStateBytes(data)) {
    return decodePersistedStateBytes(data, preferredLocalDisk)
  }
  return parse(StateSchema, data)
}
